<div class="mx-1 mb-3 mt-2 flex justify-between px-1 py-1">
  @let previousDisabled = !previousEnabled();
  @let nextDisabled = !nextEnabled();

  <button
    class="rounded-full hover:bg-gray-200 active:bg-gray-300"
    [ngClass]="{ 'pointer-events-none': previousDisabled }"
    (click)="previousClicked()"
    [attr.aria-label]="prevButtonLabel()"
    data-testid="calendar-button-prev"
  >
    <csl-icon
      [name]="'pointer-right'"
      class="!block h-6 w-6 rotate-180 bg-blue-900"
      [ngClass]="{ 'bg-gray-500': previousDisabled }"
    />
  </button>
  <button
    class="rounded-lg px-1.5 font-medium hover:bg-gray-200 active:bg-gray-300"
    (click)="currentPeriodClicked()"
    aria-label="Choose date view"
    data-testid="calendar-period"
  >
    {{ periodLabel() }}
  </button>
  <button
    class="rounded-full hover:bg-gray-200 active:bg-gray-300"
    [ngClass]="{ 'pointer-events-none': nextDisabled }"
    [disabled]="!nextEnabled()"
    (click)="nextClicked()"
    [attr.aria-label]="nextButtonLabel()"
    data-testid="calendar-button-next"
  >
    <csl-icon [name]="'pointer-right'" class="!block h-6 w-6 bg-blue-900" [ngClass]="{ 'bg-gray-500': nextDisabled }" />
  </button>
</div>
